export const name = 'swap';

export const Swap = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
  >
    <path
      d="M18.9101 6.89814L6.80267 6.85041L4.78211 10.3453"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M14.8159 2.77222L18.926 6.88227L14.869 10.9393"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M5.08963 17.1018L17.1971 17.1495L19.2176 13.6546"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9.18396 21.2278L5.0739 17.1177L9.13623 13.0554"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
